export default "__VITE_ASSET__BSLg9ha$__"